import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

// tslint:disable-next-line:max-line-length
import { BitfMatSidenavService } from '@common/libs/bitforce/core/services/sidenav/material/bitf-mat-sidenav.service';
import { BitfApiRequestPart } from '@common/libs/bitforce/core/api-call-state/bitf-api-request-part';

import {
  EBitfCloseEventStatus,
  EApiCallStateNames,
  EApiRequestPartKeys,
  ERoleActions,
  ERoleMode,
} from '@enums';
import { EFormMode } from '@common/enums/common.enum';
import { BitfFormItemConfig, FsItem, FsStore } from '@models';
import { FsService, ApiCallStateService, LoaderService } from '@services';
import { IBitfApiResponse } from '@interfaces';

@Component({
  selector: 'prada-fs-filter',
  templateUrl: './fs-filter.component.html',
  styleUrls: ['./fs-filter.component.scss'],
})
export class FsFilterComponent implements OnInit {
  mode: EFormMode;
  form: FormGroup;
  formItemsConfig: BitfFormItemConfig;
  apiCallStateName: EApiCallStateNames = EApiCallStateNames.DOCUMENT_ARCHIVE_LIST;
  requestPart: BitfApiRequestPart;
  paginationRequestPart: BitfApiRequestPart;
  isAdvancedSearch = false;
  fsStore: FsStore;

  ERoleActions = ERoleActions;
  ERoleMode = ERoleMode;

  constructor(
    private bitfMatSidenavService: BitfMatSidenavService,
    private formBuilder: FormBuilder,
    private fsService: FsService,
    private apiCallStateService: ApiCallStateService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.initRequestParts();
    this.initForm();
    this.loaderService.show();
    this.fsService
      .useFs(this.fsStore)
      .getFormItemConfig()
      .subscribe((response: IBitfApiResponse<BitfFormItemConfig>) => {
        this.formItemsConfig = response.content;
        this.patchForm();
      });
  }

  submitForm() {
    const fsItem = new FsItem({
      ...this.form.value,
    });
    switch (this.mode) {
      case EFormMode.UPDATE:
        break;
      case EFormMode.FILTER:
        this.apiCallStateService.setStore(() => {
          this.requestPart.formValue = fsItem.serialised;
          this.requestPart.data = { formItemsConfig: this.formItemsConfig };
          this.paginationRequestPart.reset();
        }, this.apiCallStateName);
        this.closeSidenav();
        break;
    }
  }

  private patchForm() {
    switch (this.mode) {
      case EFormMode.UPDATE:
        break;
      case EFormMode.FILTER:
        this.patchFormWithApiRequestPart();
        break;
    }
  }

  closeSidenav() {
    this.bitfMatSidenavService.close({ status: EBitfCloseEventStatus.CLOSE });
  }

  resetForm() {
    this.apiCallStateService.setStore(() => {
      this.paginationRequestPart.reset();
      this.requestPart.reset();
    }, this.apiCallStateName);
    this.closeSidenav();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      name: null,
      createdBy: null,
      modifiedBy: null,
      createdFrom: null,
      createdTo: null,
      modifiedFrom: null,
      modifiedTo: null,
      tags: null,
    });
  }

  private patchFormWithApiRequestPart() {
    const formValue = this.requestPart.formValue;
    if (formValue) {
      this.form.patchValue(formValue);
    }
  }

  private initRequestParts() {
    this.apiCallStateName = this.fsStore.configuration.apiCallStateName;

    const searchRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.SEARCH
    );

    this.isAdvancedSearch = searchRequestPart.formValue
      ? searchRequestPart.formValue.fullText && searchRequestPart.formValue.fullText !== ''
      : false;

    this.requestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.FILTERS
    );

    this.paginationRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.PAGINATION
    );
  }
}
